<template>
  <div class="template">
    <div class="con">
      <div class="div_info bj_white">
        <div class="div_left">
          {{orderData.id}}
          <p>{{orderData.parkName}}</p>
          <p>车牌号：{{orderData.carNum}}</p>
          <p>泊位号：{{orderData.carSpaceCode}}</p>
        </div>
        <div class="div_right">
          <span v-if="noPay == 1 && orderData.orderStatus ==1" class="font_red">待缴费</span>
          <span v-if="noPay == 1 && orderData.orderStatus ==32" class="font_red">未缴费</span>
          <span v-if="noPay == 0">正常离场</span>
          <p>停车时长
          <b>{{orderData.parkingCarTimes}}</b></p>
          <b v-if="noPay == 1" class="font_orange">¥{{(orderData.shouldPayMoney- orderData.realPayMoney).toFixed(2)}}</b>
          <b v-if="noPay == 0" class="font_orange">¥{{(orderData.shouldPayMoney).toFixed(2)}}</b>
        </div>
        <div class="div_clear"></div>
      </div>
      <div class="div_info bj_white">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in activities" :key="index" :timestamp="activity.timestamp">
            {{activity.content}}
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div class="div_info" v-if="noPay == 1" @click="pay">
      <van-button class="bt_pay" color="orangered">去缴费</van-button>
    </div>
  </div>
</template>

<script>
  import {
    mySessionStorage
  } from '@/utils/storage.js'
  export default {
    data() {
      return {
        reverse: true,
        noPay: 0,
        query: {
          openid: "",
          opType: 3,
          orderId: "",
        },
        orderData: {
          id: "",
          carNum: "",
          parkName: "",
          carSpaceCode: "",
          parkingCarTimes: "",
          shouldPayMoney: 0,
          realPayMoney: 0,
          orderStatus:0
        },
        activities: []
      };
    },
    methods: {
      getInfo() {
        this.$http.post(this.$api.getOrderInfo, {
          ...this.query
        }).then(res => {
          this.orderData = res.data;
          if ("[]" != res.data.extList) {
            for (let index in res.data.extList) {
              let ext = res.data.extList[index];
              let level = ext.payLevel == 0 ? "预缴费" : ext.payLevel == 1 || ext.payLevel == 2 ? "缴费" : "退费";
              let channel = ext.payChannel == 2 ? "现金" : ext.payChannel == 11 || ext.payChannel == 12 ? "支付宝" :
                ext.payChannel == 14 || ext.payChannel == 15 ? "微信" : ext.payChannel == 8 ? "余额" : "支付";
              let type = ext.payType == 1 ? "APP支付" : ext.payType == 2 ? "公众号支付" : ext.payType == 4 ? "无感支付" : ext.payType ==
                5 ? "POS机支付" : "扫码支付";

              this.activities.push({
                content: level,
                timestamp: type + "," + channel + ext.money + "元：" + ext.payTime
              });
            }
          } //202008131620340001
          this.activities.unshift({
            content: '车辆入场',
            timestamp: res.data.startTime
          });
          this.activities.push({
            content: '车辆出场',
            timestamp: res.data.leaveTime
          });
        });
      },
      pay() {
        this.$router.push({
          path: '/orderDetails',
          query: {
            orderId: this.orderData.id,
            shouldPay:this.orderData.shouldPayMoney,
            needPay:(this.orderData.shouldPayMoney-this.orderData.realPayMoney).toFixed(2),
            parkingTime:this.orderData.parkingCarTimes,
            startTime:this.orderData.startTime,
            parkName:this.orderData.parkName,
            type:0,
            companyId:this.orderData.companyId,
            carNum:this.orderData.carNum,
            payLevel:this.orderData.orderStatus==1?1:2
          },
        });
      }
    },
    created() {
      this.query.openid = mySessionStorage.getItem("openid");
      this.query.opType = this.$route.query.opType;
      this.query.orderId = this.$route.query.orderId;
      this.noPay = this.$route.query.noPay;
      this.getInfo();
    }
  }
</script>

<style>
  .font_red {
    color: red;
  }

  .font_orange {
    color: coral
  }

  .div_left {
    float: left;
  }

  .div_right {
    float: right;
  }

  .div_clear {
    clear: both;
  }

  .con {
    padding: 2% 1.5%;
  }

  .div_info {
    padding: 3% 3%;
    margin-bottom: 2%;
    font-size: 0.9em;
    /* background-image: linear-gradient(to top,lightblue, white ); */
  }

  .template {
    background-color: gainsboro;
    height: 100%;
    width: 100%;
  }



  .bt_pay {
    width: 100%;
    border-radius: 5px;
    height: 36px;
  }

  .bj_white {
    background: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/parkingRecord/recordInfo.vue